import { FC, useEffect, useState } from 'react';
import { Stack, SxProps, Theme, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const MessageRotator: FC<MessageRotatorProps> = ({
  uniqueMessages,
  sx = {},
  intervalMs = 5000,
  fadeDurationMs = 300,
  sxMain = {},
}) => {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visible, setVisible] = useState(true);
  const standardMessages = [
    t('common.thinking'),
    t('common.fetching_data_from_the_cloud'),
    t('common.thank_you_for_your_patience'),
    t('common.just_a_moment_we_are_processing_your_request'),
    t('common.gathering_your_data'),
    t('common.analyzing_results'),
    t('common.deep_thinking'),
    t('common.thank_you_patience'),
    t('common.just_moment'),
    t('common.crafting_perfect_result'),
    t('common.charting_optimal_path'),
    t('common.calculating_best_way'),
    t('common.working_might_take_minute'),
    t('common.almost_there'),
    t('common.everything_ready_shortly'),
    t('common.checking_final_details'),
    t('common.request_top_priority'),
  ];
  const messages = uniqueMessages || standardMessages;

  useEffect(() => {
    if (messages.length <= 1) {
      return;
    }

    const tick = () => {
      setVisible(false);
      setTimeout(() => {
        setCurrentIndex((idx) => (idx + 1) % messages.length);
        setVisible(true);
      }, fadeDurationMs);
    };

    const timer = setInterval(tick, intervalMs);
    return () => clearInterval(timer);
  }, [messages, intervalMs, fadeDurationMs]);

  return (
    <Stack direction='row' justifyContent='center' alignItems='center' sx={sxMain}>
      <Typography
        variant='body2'
        color='textSecondary'
        sx={{
          opacity: visible ? 1 : 0,
          transition: `opacity ${fadeDurationMs}ms ease-in-out`,
          ...sx,
        }}
      >
        {messages[currentIndex]}
      </Typography>
    </Stack>
  );
};

export interface MessageRotatorProps {
  uniqueMessages?: string[];
  sx?: SxProps<Theme>;
  sxMain?: SxProps<Theme>;
  intervalMs?: number;
  fadeDurationMs?: number;
}
